export default {"src":"/_next/static/media/shieldWithCheckmark_24.f551b5bc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};